module.exports = "iframe {\n  width: 100%;\n  min-height: 480px;\n  border: 0; }\n\n.hidden {\n  display: none; }\n"